import { isReactive, nextTick, reactive, readonly } from 'vue';
export { decodeWefatTextEntities, WEFAT_BASE_COMPONENT_STYLES, WEFAT_COMPONENT_DOM_VERSION, WefatText, WefatView, } from './basic-components.js';
export { sanitizeWefatRichTextNodes, WEFAT_RICH_TEXT_ALLOWED_ATTRIBUTES, WEFAT_RICH_TEXT_ALLOWED_TAGS, WEFAT_RICH_TEXT_POLICY_VERSION, WefatRichText, } from './rich-text-component.js';
export { applyWefatExternalLinkPolicy, DEFAULT_WEFAT_EXTERNAL_LINK_TARGET, resolveWefatExternalLinkRel, WEFAT_EXTERNAL_LINK_TARGET_KEY, } from './external-link-policy.js';
export { createBrowserButtonShareDriver, createWefatButtonShareEvent, resolveWefatButtonContract, WEFAT_BUTTON_OPEN_TYPES, WEFAT_BUTTON_SHARE_DRIVER, WEFAT_BUTTON_FORM_TYPES, WEFAT_BUTTON_SIZES, WEFAT_BUTTON_TYPES, WefatButton, } from './button-component.js';
export { WEFAT_PAGE_THEME_CHANGE_EVENT, WefatPageMeta, } from './page-meta-component.js';
export { installWefatPageViewportLifecycles, VuePageViewportIntegrationError, } from './page-viewport.js';
export { WefatScrollView } from './scroll-view-component.js';
export { WefatSwiper, WefatSwiperItem } from './swiper-component.js';
export { createWefatSwitchChangeDetail, resolveWefatSwitchType, WEFAT_SWITCH_TYPES, WefatSwitch, } from './switch-component.js';
export { WefatTextarea } from './textarea-component.js';
export { createWefatSelectorQuery, installWefatPageDomApis, } from './selector-query.js';
export { createWefatCustomComponent, readonlyComponentData, VueComponentIntegrationError, } from './custom-component.js';
export { vueComponentRenderer } from './vue-component-renderer.js';
export { WefatComponentRuntimeError, } from './component-error.js';
export { resolveWefatImageModeStyle, resolveWefatImageSource, WEFAT_IMAGE_MODES, WefatImage, } from './image-component.js';
export { WEFAT_INPUT_CONFIRM_TYPES, WefatInput, } from './input-component.js';
export { resolveWefatWebViewSource, WefatWebView, } from './web-view-component.js';
export { resolveWefatHoverTiming, useWefatHoverState, } from './hover-state.js';
export { adaptWefatEvent } from './mini-event-adapter.js';
export class VuePageIntegrationError extends Error {
    code = 'WF7301';
    remediation;
    constructor(message, remediation) {
        super(`WF7301 ${message}`);
        this.name = 'VuePageIntegrationError';
        this.remediation = remediation;
    }
}
export const vuePageRenderer = Object.freeze({
    makeReactive(data) {
        return reactive(data);
    },
    flush: nextTick,
});
export function readonlyPageData(page) {
    if (!isReactive(page.data)) {
        throw new VuePageIntegrationError('Cannot expose page data that was created without the Vue renderer adapter', 'Create the page with vuePageRenderer before binding its data to a generated Vue template.');
    }
    return readonly(page.data);
}
//# sourceMappingURL=index.js.map